import { z } from 'zod'

export const PiloteTeamVolunteerRecordZod = z.object({
  id: z.number(),
  is_active: z.number(),
})
